module.exports = __webpack_public_path__ + "7fd0a78465f670af0fe44c5b4b14e9f7.png";